import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function CycloneSVG({ value, config = {}, width = 60, height = 80 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? (config.run_color || '#22C55E') : (config.stop_color || '#64748B');
    const cx = width / 2;
    const bodyH = height * 0.45;
    const coneH = height * 0.4;
    const bodyY = 4;
    const coneY = bodyY + bodyH;
    const outletH = height * 0.1;
    const outletY = coneY + coneH;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Cylindrical body */}
            <rect x={8} y={bodyY} width={width - 16} height={bodyH} rx={4} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Tangential inlet stub (right side — hot air + material enters) */}
            <rect x={width - 10} y={bodyY + 6} width={10} height={8} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            {/* Cone */}
            <polygon
                points={`${8},${coneY} ${width - 8},${coneY} ${cx},${coneY + coneH}`}
                fill="#1E293B" stroke={color} strokeWidth={2}
            />
            {/* Outlet (bottom) */}
            <rect x={cx - 5} y={outletY} width={10} height={outletH} rx={2} fill="#1E293B" stroke={color} strokeWidth={1.5} />
            {/* Rotation arrow (when running) */}
            {running && (
                <text x={cx} y={bodyY + bodyH / 2 + 5} textAnchor="middle" fill={color} fontSize={10}>↺</text>
            )}
        </svg>
    );
}

export default function CycloneNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <CycloneSVG value={data?.liveValues?.state ?? data?.liveValue} config={data?.config} width={data?.width || 60} height={data?.height || 80} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
